<p-autoComplete [suggestions]="filteredList" [(ngModel)]="ngModelValue" field="value" dataKey="key" [size]="size"
    [dropdown]="true" [forceSelection]="true" [disabled]="disabled" type="search"
    (completeMethod)="search($event)" (ngModelChange)="updateChanges()" (onSelect)="onTouched()">
</p-autoComplete>